import { createClient } from "contentful";

const client = createClient({
  space: "blml0wiarabv",
  environment: "master", // defaults to 'master' if not set
  accessToken: "tZtGlzKwd-F_HAnxrp1QmyqmBJQuPi29tHoQ2Uts4Gg",
});

export default client;
